import { Theme } from '@amzn/awsui-components-core/theming';

/**
 * Central font family constant — must match the value in src/styles/_typography.scss.
 * Uses the literal string (not CSS var()) because Cloudscape's applyTheme
 * sets this as a CSS custom property value that some components resolve
 * before the :root custom property is available.
 */
export const FONT_FAMILY_BASE = "'Ember Modern Text', 'Helvetica Neue', Roboto, Arial, sans-serif";

export const APP_THEME: Theme = {
  tokens: {
    fontFamilyBase: FONT_FAMILY_BASE,
    colorBackgroundButtonPrimaryDefault: '{colorBorderButtonNormalDefault}',
    colorBackgroundButtonPrimaryActive: '{colorBorderButtonNormalActive}',
    colorBackgroundButtonPrimaryHover: '{colorBorderButtonNormalHover}',
    colorTextButtonPrimaryDefault: '{colorTextInverted}',
    colorTextButtonPrimaryActive: '{colorTextInverted}',
    colorTextButtonPrimaryHover: '{colorTextInverted}',
  },
};
